import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getData } from '../redux/actions/restaurant';

function PrivacyPolicy({ getData, aboutus, domain_name, company_name }) {
    const [close, SetClose] = useState(false);

    useEffect(() => {
        getData();

    }, [])


    const closeMe = () => {
        SetClose(true);
    }

    if (close) {
        return <Redirect to="/" />
    }

    return (
        <>
            <header className="fixed header-blue">
                <div className="container">
                    <div className="header-top">
                        <div className="header-top-left">
                            <span className="back"><img className="img-dark" src="/images/arrow-back.png" alt="" />
                                <img className="img-white" src="/images/arrow-back-white.png" alt="" onClick={closeMe} />
                            </span>
                        </div>
                        <div className="header-top-mid">
                            <span className="font-semibold">Privacy Policy</span>
                        </div>
                        <div className="header-top-right"></div>
                    </div>
                </div>
            </header>
            <div className="view-cart" style={{ marginTop: "51px" }}><div className="container">
                <div class="starter-template">
                    <p class="lead"><u>Terms of Use</u></p>
                    <p>
                        {domain_name}
    is owned and operated by
    {company_name} a company incorporated under the laws of India. Your use of the Website and
    services and tools are governed by the following terms and conditions
    ("Terms of Use") as applicable to the Website including the applicable
    policies which are incorporated herein by way of reference. If you transact
    on the Website, You shall be subject to the policies that are applicable to
    the Website for such transaction. By mere use of the Website, You shall be
    contracting with
    {company_name}  and these terms and conditions including the policies constitute your
    binding obligations, with
    {company_name} and these terms and conditions including the policies constitute your
    binding obligations, with {company_name}. For the purpose of these Terms of
    Use, wherever the context so requires "You" or "User" shall mean any natural
    or legal person who has agreed to become a buyer on the Website by providing
    Registration Data while registering on the Website as Registered User using
    the computer systems.
    {domain_name} allows the User to surf the Website or making purchases without registering
    on the Website. The term "We", "Us", "Our" shall mean {company_name}
    When You use any of the services provided by Us through the Website,
    including but not limited to, (e.g. Product Reviews, Seller Reviews), You
    will be subject to the rules, guidelines, policies, terms, and conditions
    applicable to such service, and they shall be deemed to be incorporated into
    this Terms of Use and shall be considered as part and parcel of this Terms
    of Use. We reserve the right, at our sole discretion, to change, modify, add
    or remove portions of these Terms of Use, at any time without any prior
    written notice to you. It is your responsibility to review these Terms of
    Use periodically for updates / changes. Your continued use of the Website
    following the posting of changes will mean that you accept and agree to the
    revisions. As long as you comply with these Terms of Use, We grant you a
    personal, non-exclusive, non-transferable, limited privilege to enter and
    use the Website
  </p>
                    <br />

                    <p class="lead"><u>Privacy Policy</u></p>
                    <p style={{ textAlign: "justify" }}>
                        For us privacy for our valued customer is very important. We strongly
                        believe that the personal information of our customers should not be shared
                        with the third party without the prior consent or request from the customer.
                        Privacy is the right of an individual and at{company_name} the information of the customer such as contact no., email, addresses etc.
    is used only for the internal purpose and not for sale. Your contact
    information is stored in our database and is only used to contact you during
    the course of your order with us for sharing the status of your order
    bookings with us etc. We at {company_name} condemn the unauthorized reach and misuse and/or discloser of the personal
    information of the customer and we have strict guidelines and high security
    features to prevent the same. Any changes in our ‘Privacy Policy’ will be
    posted here on the website. SECURE ONLINE PAYMENTS The visitor on our
    website please take a note that your name, email address and other personal
    information submitted on our website may be stored with us and may also
    appear on the website. Like other platforms our server log files also
    receives general information such as IP address of the visitor, cookie etc.
    For the financial transactions by credit card {company_name}
    uses a 3rd party secure payment gateway provided by “PayU” and the credit
    card details are ‘not stored’ with Yasin's Food Inn instead the information
    is securely stored and encrypted with Visa/MasterCard. Smart Cookies We use
    'Cookies' to keep track of your current shopping session to personalize your
    experience and so that you may retrieve your shopping cart at any time.
    'Cookies' are tiny text files which our Website places on your computer's
    hard drive to store information about your shopping session and to identify
    your computer.
  </p>
                    <br />

                    <p class="lead"><u>Return, Refund and Cancellation Policy</u></p>
                    <p style={{ textAlign: "justify" }}>
                        After placing the order customer can cancel the order within 15mins if
                        he/she wish to. And in case of customer request for Refund, it will be
                        processed through same mode within 10 working days. Being a food item we do
                        not entertain Return.
  </p>
                    <br />

                    <p class="lead"><u>Shipping and Delivery Policy</u></p>
                    <p style={{ textAlign: "justify" }}>
                        {domain_name}
    promises to provide you with a best-in-class Food Home Delivery at every
    step of the way. We assure you that all due precautions are taken so that
    your package reaches you intact. We take pride in delivering on time, every
    time!! If you have ordered with us earlier, we are of course confident that
    you already vouch for us! <br />
    An estimated Delivery Time (20 minutes to 60 minutes) is confirmed at the
    Time of Order Confirmation, through Call or SMS. Invoice will be sent on
    mail id provided. Delivery could take a little longer for reasons that might
    be inevitable, from Delivery Boy or Vendor side. You will receive an
    Email/SMS with the order number as soon as the order is confirmed. <br />
    Restaurant Timings are mentioned on the Home tab of our Web Page. Delivery
    is un-interrupted throughout all the days, unless there is some Major
    Holiday or any factor that is beyond human being's control.
  </p>
                    <br /><br />
                </div>

            </div></div>
        </>
    )
}

const mapStateToProps = (state) => ({
    aboutus: state.restaurant?.details?.about_us,
    domain_name: state.restaurant?.details?.company_name,
    company_name: state.restaurant?.details?.domain_name,
})

export default connect(mapStateToProps, { getData })(PrivacyPolicy)



